module.exports = __webpack_public_path__ + "static/media/default-file.8a9080a0.svg";